import React, { FC, useState } from 'react';
import styles from './header.module.css';
import './header-bugger.scss';
import clsx from 'clsx';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { Menu } from '../Menu';
import { LoginButton } from './LoginButton';
// import { FirebaseMenuClick } from '../../firebase/otherClick';

export const Header: FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useScrollPosition(
    ({ currPos }) => {
      setIsVisible(currPos.y < -5);
    },
    [isVisible]
  );

  return (
    <>
      <div
        className={`mx-auto 
          ${styles.frame} 
          z-10 
          bugger
          transition-colors
          duration-300
          ${isVisible ? 'sm:bg-black sm:bg-opacity-40' : ''}`}
      >
        <div className={clsx(styles.img, 'z-20')}>
          <input type="checkbox" id="menuToggle"></input>

          <label htmlFor="menuToggle" className="menuOpen">
            <div
              className="open"
              onClick={() => {
                // FirebaseMenuClick();
              }}
            ></div>
          </label>
          <div className="menu menuEffects">
            <label htmlFor="menuToggle"></label>
            <Menu />
          </div>
        </div>
        <img
          className={styles.logo}
          alt="Element"
          src="/assets/images/home/2-5-3.svg"
        />
        <LoginButton />
        {/* <img
          className={styles.img}
          alt="Account circle"
          src="/assets/images/home/account-circle.png"
        /> */}
      </div>
    </>
  );
};
